import {
    COMMON_API_NEXT_URL,
    COMMON_API_URL,
    isDevelopment,
    isProductionHost,
    isTestHost,
} from '../../general/config';

export const API_COMMON_URL =
    (isDevelopment || isTestHost) && !isProductionHost ? COMMON_API_NEXT_URL : COMMON_API_URL;

export const REQUEST = '_REQUEST';
export const SUCCESS = '_SUCCESS';
export const FAILURE = '_FAILURE';

export const SUCCESS_STATUS = 'SUCCESS';
export const FAILED_STATUS = 'FAILED';
export const UNKNOWN_STATUS = 'Unknown Error!';
export const SAVE_KEY = 'Save key';
export const ERASE_KEY = 'Erase key';
export const SAVE_PRODUCT_ID = 'Save product id';
export const CHECK_KEY = 'Check key';

export const HIDDEN_BUTTON_CLASS = 'is-transparent';

export const FILTERS = 'FILTERS';
export const PERIODS = 'PERIODS';
export const CURRENCY = 'CURRENCY';

export const AUTH = 'AUTH';
export const REGISTER = 'REGISTER';
export const LOGOUT = 'LOGOUT';
export const SET = '_SET';
export const EMAIL = 'EMAIL';
export const USER_ID = 'USER_ID';
export const USER_INFO = 'USER_INFO';
export const SAVE_CLIENT_SECRET = 'SAVE_CLIENT_SECRET';
export const SAVE_PROMO_CODES = 'SAVE_PROMO_CODES';
